import { configureStore } from '@reduxjs/toolkit';
import roleSlice from '../features/roleSlice';
import moduleSlice from '../features/moduleSlice';
import staffSlice from '../features/staffSlice';

const store = configureStore({
    reducer: {
        role: roleSlice.reducer,
        module: moduleSlice.reducer,
        staff: staffSlice.reducer
    }
});

export default store;